import UrlInput from './component';
import { UrlInputProps } from './types';

export default UrlInput;
export type { UrlInputProps };
